import 'swiper/css';
import './slider.css'
import 'swiper/css/navigation';
import { ReactNode } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

function Slider({ cards }: { cards: ReactNode[] }) {

    return (
        <Swiper
            speed={900}
            loop={false}
            spaceBetween={10}
            slidesPerView={7}
            navigation={true}
            slidesPerGroup={3}
            className={"swiper"}
            modules={[Navigation]}
            breakpoints={{
                450: { slidesPerView: 3, spaceBetween: 20 },
                640: { slidesPerView: 3, spaceBetween: 20 },
                768: { slidesPerView: 5, spaceBetween: 20 },
                1024: { slidesPerView: 7, spaceBetween: 10 },
            }}
        >
            {
                cards.map((card, index) =>
                    <SwiperSlide key={index}>
                        {card}
                    </SwiperSlide>
                )
            }
        </Swiper>
    );
};

export { Slider }